import { FormGroup, FormParagraph } from '@ksyos/design-system';
import type { IOrthOProcedureCustomControlData } from '../../../../../common/interfaces/ophthalmology/orthO/orthOProcedureCustomControlData';
import type { OrthOExaminationOrder } from './orthOExaminationOrder';
import type { IOrthOV1ProcedureProps } from './OrthOV1ProcedureRead';
import { translateKey } from '../../../../translate';
import { InputTextField } from '../../../userDataManagement/InputText';

interface IReadOrEditInputFieldProps extends IOrthOV1ProcedureProps {
    error: string | undefined;
    fieldKey: keyof IOrthOProcedureCustomControlData;
    hasErrors?: boolean;
    isRequired: boolean;
    label: string;
    placeholder: string;
    tabIndex: OrthOExaminationOrder;
    value: string | null;
}

export function ReadOrEditInputField(props: IReadOrEditInputFieldProps) {
    if (!props.isReadOnly) {
        return <InputTextField {...props} />;
    } else if (props.value) {
        return (
            <FormGroup label={translateKey(props.label)}>
                <FormParagraph>{props.value}</FormParagraph>
            </FormGroup>
        );
    }

    return <></>;
}
